export function formatCnpj(
  value: unknown,
  opts?: { fallback?: string }
): string {
  const fallback = opts?.fallback ?? "-";

  try {
    if (value == null) return fallback;

    const raw = String(value);
    const digits = raw.replace(/\D/g, "");
    if (digits.length !== 14) return raw || fallback;

    return digits.replace(
      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
      "$1.$2.$3/$4-$5"
    );
  } catch {
    return typeof value === "string" && value.length ? value : fallback;
  }
}